
import { z } from 'zod';
import {
  NameSchema,
  FirstNameSchema,
  LastNameSchema,
  OwnerRolesSchema,
  DEFAULT_OWNER_ROLES,
} from '@shared/user';
import { MIN_PASSWORD_LENGTH, PasswordSchema } from '@client/shared/auth/index.ts';

export { MIN_PASSWORD_LENGTH, PasswordSchema };

export const SetupLoginFormSchema = z.object({
  firstName: FirstNameSchema,
  lastName: LastNameSchema,
  password: PasswordSchema,
});

export type SetupLoginFormInput = z.infer<typeof SetupLoginFormSchema>;

export const EMPTY_SETUP_LOGIN_FORM: SetupLoginFormInput = {
  firstName: '',
  lastName: '',
  password: '',
};

export const CreateOrgInputSchema = z.object({
  organizationName: NameSchema,
  ownerRoles: OwnerRolesSchema,
});

export type CreateOrgInput = z.infer<typeof CreateOrgInputSchema>;

export const EMPTY_CREATE_ORG: CreateOrgInput = {
  organizationName: '',
  ownerRoles: [...DEFAULT_OWNER_ROLES],
};
